var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: _vm.titulo, width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _vm.dadosVtn
          ? _c(
              "div",
              [
                _vm.dadosVtn
                  ? _c("VisualizarVtnAP", {
                      attrs: {
                        vtn: _vm.dadosVtn,
                        processo: _vm.processo,
                        isUsuarioExterno: false,
                        isVisualizar: true
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-398857e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398857e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppModalVisualizarVTNAP.vue
// module id = null
// module chunks = 